import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseFolderModel from "../../models/case-folder";

export default class CaseFolderRepository extends BaseRepository {
  static modelClass = CaseFolderModel;
  modelName = "case-folder";
}
